import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../Pages/InputField/DataTable"; // Import the reusable DataTable component
import { Row, Col, Button } from "react-bootstrap";
import { format } from "date-fns"; // Import date-fns for date formatting
import baseURL from "../../../../Url/NodeBaseURL";
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";

const RepairsTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]); // State to store table data
  const [loading, setLoading] = useState(true); // State to handle loading
  const [filteredRows, setFilteredRows] = useState([]);

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURL}/get/rates`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        // Map rate_date to date before passing to DataTable
        const modifiedData = result.map((item) => ({
          ...item,
          date: item.rate_date, // Rename rate_date to date
        }));

        setData(modifiedData); // Set the modified data
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading spinner
      }
    };

    fetchData();
  }, []);

  // Excel download function
  const downloadExcel = () => {
    const exportData = filteredRows.length ? filteredRows : data;

    const excelData = exportData.map((item, index) => ({
      "S No.": index + 1,
      Date: new Date(item.date).toLocaleDateString("en-GB"),
      "16 Crt": item.rate_16crt || "",
      "18 Crt": item.rate_18crt || "",
      "22 Crt": item.rate_22crt || "",
      "24 Crt": item.rate_24crt || "",
      Silver: item.silver_rate || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Rates Report");

    XLSX.writeFile(
      workbook,
      `Rates_Report_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S No.",
        Cell: ({ row }) => row.index + 1, // Generate a sequential number based on the row index
      },
      {
        Header: "Date",
        accessor: "date", // Access the renamed date field
        Cell: ({ value }) => {
          const date = new Date(value);
          return date.toLocaleDateString("en-GB"); // en-GB for dd/mm/yyyy format
        },
      },
      {
        Header: "16 Crt",
        accessor: "rate_16crt",
      },
      {
        Header: "18 Crt",
        accessor: "rate_18crt",
      },
      {
        Header: "22 Crt",
        accessor: "rate_22crt",
      },
      {
        Header: "24 Crt",
        accessor: "rate_24crt",
      },
      {
        Header: "Silver",
        accessor: "silver_rate",
      },
    ],
    [],
  );

  return (
    <div className="main-container">
      <div className="sales-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Rates</h3>
            <Button
              variant="success"
              onClick={downloadExcel}
              className="d-flex align-items-center gap-2"
              disabled={loading || data.length === 0}
            >
              <FaFileExcel />
              Download Excel
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div>Loading...</div> // Loading indicator
        ) : (
          <DataTable
            columns={columns}
            data={data}
            onFilterChange={setFilteredRows}
          />
        )}
      </div>
    </div>
  );
};

export default RepairsTable;
